import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";
import { NotificationBell as SharedNotificationBell } from "@tabipla/components";
import {
  useNotifications,
  useMarkNotificationRead,
  useMarkAllNotificationsRead,
  useDeleteNotification,
} from "@/application/hooks/useNotifications";
import type { NotificationResponseDto } from "@tabipla/shared";

export function NotificationBell() {
  const navigate = useNavigate();

  const { data } = useNotifications();
  const markRead = useMarkNotificationRead();
  const markAllRead = useMarkAllNotificationsRead();
  const deleteNotification = useDeleteNotification();

  const unreadCount = data?.unreadCount ?? 0;
  const notifications = data?.notifications ?? [];

  const handleNavigate = (notification: NotificationResponseDto) => {
    // Mark as read
    if (!notification.read) {
      markRead.mutate(notification.id);
    }

    // Navigate to related page (Waritto focuses on groups)
    if (notification.groupId) {
      navigate(`/groups/${notification.groupId}`);
    }
  };

  return (
    <SharedNotificationBell
      notifications={notifications}
      unreadCount={unreadCount}
      onMarkRead={(id) => markRead.mutate(id)}
      onMarkAllRead={() => markAllRead.mutate()}
      onDelete={(id) => deleteNotification.mutate(id)}
      onNavigate={handleNavigate}
      isMarkAllReadPending={markAllRead.isPending}
      notificationIcons={{
        trip_updated: Users,
      }}
    />
  );
}
